export function VisionMissionBG() {
  return (
    <svg
      viewBox="0 0 1920 1977"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 min-h-full"
    >
      <g clipPath="url(#clip0_598_3172)">
        <rect fill="#011E62" className="size-full" />
        <g filter="url(#filter0_f_598_3172)">
          <circle cx="261" cy="246" r="199" fill="#0046BB" />
        </g>
        <g filter="url(#filter1_f_598_3172)">
          <circle cx="261" cy="1336" r="199" fill="#0046BB" />
        </g>
        <g filter="url(#filter2_f_598_3172)">
          <circle cx="1226" cy="868" r="199" fill="#0046BB" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_598_3172"
          x="-238"
          y="-253"
          width="998"
          height="998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_598_3172"
          />
        </filter>
        <filter
          id="filter1_f_598_3172"
          x="-238"
          y="837"
          width="998"
          height="998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_598_3172"
          />
        </filter>
        <filter
          id="filter2_f_598_3172"
          x="727"
          y="369"
          width="998"
          height="998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_598_3172"
          />
        </filter>
        <clipPath id="clip0_598_3172">
          <rect width="1920" height="1977" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
